// extracted by mini-css-extract-plugin
export default {"FruitCard":"FruitCard_FruitCard__a2h2V","isSelected":"FruitCard_isSelected__6s5Im"};